<template>
  <el-card class="fla__card">
    <h2>Film{{ (value.length > 1) ? 's' : '' }}
      <el-button
        type="text"
        @click="$refs.formFilms.addTab()"
        icon="el-icon-circle-plus"
      >
        Add more films
      </el-button>
    </h2>

    <FilmsForm
      ref="formFilms"
      :value="value"
      v-bind="$attrs"
      @input="newValue => $emit('input', newValue)"
    />
  </el-card>
</template>

<script>
import FilmsForm from '@/components/Licenses/Others/FilmsForm';

export default {
  inheritAttrs: false,
  components: {
    FilmsForm,
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.licenseRendererVm.addReference('formFilms', this.$refs.formFilms);
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppYourFilm.vue